/* AIS Officers Healthcare Admin — Design Tokens */

export const colors = {
  navy900: '#0A1628',
  navy800: '#132A4A',
  navy700: '#1C3D6E',
  navy600: '#2A5494',
  navy500: '#3B6DB5',
  gold: '#C9A84C',
  goldLight: '#E4C76B',
  goldDark: '#A88B3A',
  goldSoft: 'rgba(201,168,76,0.12)',
  success: '#22C55E',
  successSoft: 'rgba(34,197,94,0.1)',
  warning: '#F59E0B',
  warningSoft: 'rgba(245,158,11,0.1)',
  error: '#EF4444',
  errorSoft: 'rgba(239,68,68,0.1)',
  info: '#3B82F6',
  infoSoft: 'rgba(59,130,246,0.1)',
  bgMain: '#F7F8FA',
  bgCard: '#FFFFFF',
  bgSubtle: '#F1F3F7',
  textPrimary: '#0F1B2D',
  textSecondary: '#5A6B82',
  textMuted: '#94A3B8',
  textFaint: '#CBD5E1',
  borderLight: '#E8ECF2',
  borderMain: '#D4DAE3',
};

export const formatCurrency = (amount: number | string): string =>
  '₹' + Number(amount).toLocaleString('en-IN');

export const statusConfig: Record<string, { bg: string; color: string; label: string }> = {
  draft: { bg: colors.bgSubtle, color: colors.textMuted, label: 'Draft' },
  submitted: { bg: colors.infoSoft, color: colors.info, label: 'Submitted' },
  under_review: { bg: colors.warningSoft, color: colors.warning, label: 'Under Review' },
  approved: { bg: colors.successSoft, color: colors.success, label: 'Approved' },
  payment_80_done: { bg: colors.successSoft, color: colors.success, label: '80% Paid' },
  treatment_ongoing: { bg: colors.infoSoft, color: colors.info, label: 'Treatment Ongoing' },
  final_settlement: { bg: colors.warningSoft, color: colors.warning, label: 'Final Settlement' },
  completed: { bg: colors.successSoft, color: colors.success, label: 'Completed' },
  rejected: { bg: colors.errorSoft, color: colors.error, label: 'Rejected' },
};
